import { Button } from '@/components';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useOrganizationTemplateDrawerState } from './OrganizationTemplateDrawerStateProvider';

export const CreateOrganizationTemplateButton: FC = () => {
  const { t } = useTranslation();
  const { setDrawerState } = useOrganizationTemplateDrawerState();
  return (
    <Button
      type="primary"
      onClick={() => {
        setDrawerState({ open: true, operation: 'create' });
      }}
    >
      {t('create-organization-template')}
    </Button>
  );
};
